import request from "@/utils/request";

// 验证码
export function getValidateCodeApi(data) {
  return request({
    url: `/fmsapi/common/AddValidCodeThenSend`,
    method: "post",
    data,
  });
}

// 货币类型
export function getCurrencyApi(data) {
  return request({
    url: `/fmsapi/common/GetSearchCurrency`,
    method: "post",
    data,
  });
}

// 国家
export function getCountryApi(data) {
  return request({
    url: `/fmsapi/common/GetRegisterCountry`,
    method: "post",
    data,
  });
}

// 省
export function getProvinceApi(data) {
  return request({
    url: `/fmsapi/common/GetRegisterProvince`,
    method: "post",
    data,
  });
}

// 市
export function getCityApi(data) {
  return request({
    url: `/fmsapi/common/GetRegisterCity`,
    method: "post",
    data,
  });
}
